import { BiChevronLeft, BiDotsHorizontalRounded } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { logout } from "../../api/auth";


const TabItem = ({onClick, text}) => {
  
    return (
        <div
            onClick={onClick}
            style={{
                padding: '0px 0px'
            }}
        >
            <span
                style={{
                    color: '#333D4B', // var(--x-gray-90) 폴백 컬러
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '100%', // 또는 '19.6px'
                    letterSpacing: '-0.5px',
                }}
            >
                {text}
            </span>
        </div>
    )
}

const TabMenu = ({setIsTabOpen}) => {
    const navigate = useNavigate()

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            style={{
                background: '#FFFFFF',
                position: 'absolute',
                bottom: -120,
                right: 0,
                borderRadius: '12px',
                boxShadow: '0 7px 29px 0 rgba(100, 100, 111, 0.20)',
                width: '100px',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}
        >
            <TabItem
                text={"문의 응답"}
                onClick={() => {
                    setIsTabOpen(false)
                    navigate("/tasks/infos")
 
                }}
            />
            <TabItem
                text={"예약 관리"}
                onClick={() => {
                    setIsTabOpen(false)
                    navigate("/tasks/reservations")
           
                }}
            />
            <TabItem
                text={"결제 관리"}
                onClick={() => {
                    setIsTabOpen(false)
                    navigate("/tasks/payments")
            
                }}
            />
        </div>
    )
}





const Header = ({
    isBackEnabled = false,
}) => {
    const navigate = useNavigate();
    const [isTabOpen, setIsTabOpen] = useState(false);
    const { setIsLoggedIn, selectedStore, clearOnboarding } = useAuth();

    


    const handleLogout = async () => {

        // 사용자 경험을 위해 확인창을 쓸 수 있습니다 (선택 사항)
        // if (!window.confirm("로그아웃 하시겠습니까?")) return;
    
        try {
            // 1. 서버 세션(쿠키) 삭제 요청
            await logout();

            
            // 2. 리액트 전역 상태 즉시 업데이트
            // 이 코드가 실행되는 순간 Header 등의 UI가 즉시 비로그인 상태로 바뀝니다.
            clearOnboarding();
            setIsLoggedIn(false);
    
            // 3. 페이지 이동 (필요 시)
            // 로그인 상태가 아예 지워졌으므로 리액트 렌더링 사이클을 고려해 이동합니다.
            setTimeout(() => {
                navigate("/", { replace: true });
            }, 50);
            
        } catch (error) {
            console.error("로그아웃 실패:", error);
            alert("로그아웃 중 오류가 발생했습니다.");
        }
    };

    

    return (
        <div
            style={{
                width: '100%',
                height: '60px',
                // border: '1px solid black',
                display: 'flex',
                alignItems: 'center',
                padding: '24px',
                background: '#FFFFFF',
            }}
        >
            {
                isBackEnabled ? 
                    <div
                        onClick={() => {
                            navigate("/");
                        }}
                        style={{
                            width: '36px',
                            height: '36px',
                            // border: '1px solid black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer'
            

                        }}
                    >

                        <BiChevronLeft size={24} color="#727272"/>
                    </div>
                :
                    <div
                        style={{
                            width: '36px',
                            height: '36px',
                            // border: '1px solid black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
            

                        }}
                    >
                    </div>
            }

            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                    }}
                >

                    {selectedStore ? (
                        <>
                            <div
                                style={{
                                    width: '36px',
                                    height: '36px',
                                    border: '1px solid #EFEFEF',
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    flexShrink: 0,
                                }}
                            >
                                <img
                                    src={selectedStore.logo_image_url}
                                    alt={selectedStore.name}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <span
                                onClick={handleLogout}
                                style={{
                                    fontSize: '16px',
                                    fontFamily: "Pretendard",
                                    fontWeight: 600,
                                    lineHeight: 1,
                                    color: '#212121',
                                    cursor: 'pointer'
                                }}
                            >
                                {selectedStore.name}
                            </span>
                        </>
                    ) : (
                        <span style={{
                            fontSize: '16px',
                            fontFamily: "Pretendard",
                            fontWeight: 600,
                            lineHeight: 1,
                            color: '#212121',
                        }}>
                            띠링, 보이스 에이전트
                        </span>
                    )}
                </div>
        
            </div>
            <div
                onClick={() => {
                    setIsTabOpen(!isTabOpen)
                }}
                style={{
                    width: '36px',
                    height: '36px',
                    // border: '1px solid black',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    position: 'relative'

                }}
            >
                <BiDotsHorizontalRounded size={24} color="#727272"/>

                {
                    isTabOpen && (
                        <TabMenu 
                            setIsTabOpen={setIsTabOpen}
                        />
                    )
                }

            </div>

        </div>
    )
}

export default Header;
